import React from 'react'
import './App.css';
import {ListView} from 'react-native';
import firebase from './Firebase';

export class Highlights extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            dataSource: new ListView.DataSource({
                rowHasChanged: (row1, row2) => row1 !== row2
            }),
           highlights: [],
        }
    }

    componentWillMount() {
        var that = this;
        // Get the list of highlights from firebase
        firebase.database().ref('Highlights/').on('value', function(data) {
            that.setState({
                highlights: data.val()
            });
            that.state = {
                dataSource: that.state.dataSource.cloneWithRows(data.val())
            };
        })
    }

    highlightCard = (highlight) => {
        return (
            <div className="highlight-container">
                <div className="highlight-cover">
                    <img
                        style={{width: "100%", height: "100%",
                            borderTopLeftRadius: "5px", borderTopRightRadius: "5px",
                            objectFit: "cover"}}
                        src={highlight.coverImageURL} alt="CoverPhoto"/>
                </div>

                <div className="highlight-info">

                    <p className="highlight-title">
                        {highlight.title}
                    </p>

                    <p className="highlight-description">
                        {highlight.description.substring(0, 120)}
                    </p>

                </div>

            </div>

        )
    }
    
    
    render() {
        return (
            <div className="highlight-section">
                <p className="highlight-header">Highlights</p>
                <ListView
                    dataSource={this.state.dataSource}
                    renderRow={this.highlightCard}
                    horizontal={true}
                />
            </div>
        )
    }
}

export default Highlights



// WEBPACK FOOTER //
// ./src/Highlights.js